export const classes = {
  list: 'flex flex-col items-center gap-1 py-2 overflow-y-auto h-full',
  upButton: 'mb-1',
  itemButton:
    'w-12 h-12 rounded-lg border border-transparent hover:border-brand-accent/50 transition-colors place-center cursor-pointer bg-black/[0.04] dark:bg-white/[0.06] dark:hover:border-brand-accent-dark/50',
  itemActive:
    'border-brand-accent hover:border-brand-accent dark:border-brand-accent-dark dark:hover:border-brand-accent-dark',
  folderIcon: 'text-brand-accent text-2xl dark:text-brand-accent-dark',
  thumbWrapper: 'w-full h-full rounded-md overflow-hidden place-center',
  thumbImg: 'w-full h-full object-cover',
};
